import React from 'react';
import ToolFilterText from '../../containers/ToolFilterText';

const DropdownItem = ({ user, selected, onMouseOver, onClick }) => (
  <div
    className={`item${selected ? ' selected' : ''}`}
    onMouseOver={onMouseOver}
    onClick={onClick}
  >
    <div className="username">
      <ToolFilterText
        filter="searchBoxText"
        text={user.name}
      />
    </div>
    <div className="usergroups">
      <ToolFilterText
        filter="searchBoxText"
        text={user.groups.map(group => group.groupname).join(', ')}
      />
    </div>
  </div>
);

export default DropdownItem;



// WEBPACK FOOTER //
// ./src/components/SearchBox/DropdownItem.jsx